import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { OnlyInDesktopTablet } from '@components/shared';
import s from './Title.module.less';

const Separator = ({
  pipe = false,
  alwaysShow = false,
}: {
  pipe?: boolean;
  alwaysShow?: boolean;
}) => (
  <span className={cn(s.separator, pipe && s.pipeSeparator, alwaysShow && s.show)}>
    {pipe ? '|' : '-'}
  </span>
);

type Props = {
  primaryName: string | null;
  secondaryName: string | null;
  cityLocalityRegion: string | null;
  countryCode: string | null;
  neighborhood: string | null;
};

const Title = ({
  primaryName,
  secondaryName = null,
  cityLocalityRegion,
  countryCode,
  neighborhood = null,
}: Props) => {
  const { t } = useTranslation();
  const renderCityLocalityRegion = () => (
    <>
      <OnlyInDesktopTablet>
        <Separator pipe alwaysShow />
      </OnlyInDesktopTablet>
      {neighborhood ? (
        <>
          {neighborhood}
          <Separator pipe alwaysShow />
        </>
      ) : null}
      {cityLocalityRegion}
      <Separator pipe alwaysShow />
      {t(`country:${countryCode}`)}
    </>
  );

  return (
    <div className={s.container}>
      <div className={s.title}>
        <Typography.Title className={s.titleText}>
          {primaryName}
          {secondaryName ? (
            <div className={s.secondaryNameContainer}>
              <Separator />
              {secondaryName}
            </div>
          ) : null}
        </Typography.Title>
        <Typography.Title className={s.secondaryInformation}>
          {renderCityLocalityRegion()}
        </Typography.Title>
      </div>
    </div>
  );
};

export default Title;
